import React from 'react';
import PropTypes from 'prop-types';
import { setUpPropsByDevice } from '../../utils/common';
import { errorLog } from '../../utils/logUtils';
import {
  ICONS_ID as ICONS_ID_UTILS,
  ICON_SOURCE as ICON_SOURCE_UTILS,
} from './utils';
import './SvgIconLoader.scss';

export const ICONS_ID = ICONS_ID_UTILS;
export const ICON_SOURCE = ICON_SOURCE_UTILS;

export const SEGMENT = {
  PARTICULARES: 'particulares',
  GP: 'gp',
  EMP: 'emp',
  EMPRESAS: 'empresas',
};

export const SVG_ICON_KIND = {
  LIGHT: 'L',
  MEDIUM: 'M',
  SOLID: 'S',
};

export const COLOR = {
  WHITE: 'white',
  BLACK: 'black',
  GREEN: 'green',
  GREEN_1: 'green1',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_0: 'grey0',
  GREY_A: 'greya',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_2: 'grey2',
  GREY_3: 'grey3',
  GREY_4: 'grey5',
  GREY_4A: 'grey4a',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_6: 'grey6',
  GREY_7: 'grey7',
  GREY_8: 'grey8',
  GREY_9: 'grey9',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  EGG: 'egg',
  EGG_LIGHT: 'egg-light',
  EGG_DARK: 'egg-dark',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  RED: 'red',
  RED_1: 'red1',
  RED_LIGHT: 'red-light',
  RED_DARK: 'red-dark',
  INHERIT: 'inherit',
  TRANSPARENT: 'transparent',
};

export const convertToOptions = (optionsObject) => {
  const keys = Object.keys(optionsObject);
  return keys.map((key) => {
    return optionsObject[key];
  });
};

const getProperCollection = (id, kind) => {
  let res = null;
  if (ICON_SOURCE[id] && ICON_SOURCE[id][kind]) {
    res = ICON_SOURCE[id][kind];
  }
  return res;
};

const SvgIconLoader = (props) => {
  const myProps = setUpPropsByDevice(props);
  const {
    id,
    kind,
    className,
    color,
    collectionSource,
    segment,
    size,
    layoutSize,
    sizeCircular,
    backgroundColor,
  } = myProps;

  if (!id) {
    return null;
  }

  if (!ICONS_ID[id]) {
    return null;
  }

  const myId = ICONS_ID[id].toLowerCase() || id.toLowerCase();
  const myKind = kind.toLowerCase();
  // ICONS_ID
  const source = collectionSource || getProperCollection(myId, myKind);

  if (!source) {
    errorLog(`${source} is not linked to any glyph collection`);
    return null;
  }

  /* si no hay layoutSize lo fabrico apartir del size,
  confio en redimensionamiento del icono */
  let myLayoutSize = {};
  // si hay layout size lo aplico
  if (layoutSize && layoutSize.h && layoutSize.w) {
    myLayoutSize = {
      h: `${layoutSize.h / 16}rem`,
      w: `${layoutSize.w / 16}rem`,
    };
  }

  const style = {
    fontSize: `${size / 16}rem`,
  };

  if (myLayoutSize && myLayoutSize.h && myLayoutSize.w) {
    style.height = myLayoutSize.h;
    style.width = myLayoutSize.w;
  }

  const cssCircular = `${sizeCircular > 0 ? ' SvgIconLoader-circular' : ''}`;
  if (cssCircular) {
    style.padding = `${sizeCircular / 16}rem`;
  }
  let mySegment = segment;
  switch (segment) {
    case 'empresas':
    case 'emp':
      mySegment = 'emp';
      break;
    case 'particulares':
    default:
      mySegment = 'gp';
      break;
  }

  const cssColor = ` SvgIconLoader-color-${mySegment}--${color}`;
  const cssBackground = ` SvgIconLoader-bgColor-${mySegment}--${backgroundColor}`;
  const cssCurrentIcon = ` icon${source}-${myId}-${myKind}`;
  const ownClassName = `${className ? ` ${className}` : ''}`;
  const myClassName = `SvgIconLoader${cssCurrentIcon}${cssColor}${cssBackground}${cssCircular}${ownClassName}`;

  return <span className={myClassName} style={style} />;
};

SvgIconLoader.propTypes = {
  id: PropTypes.string.isRequired,
  kind: PropTypes.oneOf(convertToOptions(SVG_ICON_KIND)),
  className: PropTypes.string,
  color: PropTypes.oneOf(convertToOptions(COLOR)),
  size: PropTypes.number,
  collectionSource: PropTypes.number,
  layoutSize: PropTypes.shape({
    w: PropTypes.number,
    h: PropTypes.number,
  }),
  sizeCircular: PropTypes.number,
  backgroundColor: PropTypes.oneOf(convertToOptions(COLOR)),
  segment: PropTypes.oneOf(convertToOptions(SEGMENT)),
};

SvgIconLoader.defaultProps = {
  kind: SVG_ICON_KIND.MEDIUM,
  className: '',
  color: COLOR.BLACK,
  size: 16,
  collectionSource: 0,
  layoutSize: null,
  sizeCircular: 0,
  backgroundColor: COLOR.TRANSPARENT,
  segment: SEGMENT.GP,
};

export default SvgIconLoader;
